import { gql } from '@apollo/client';

const WorkoutProgramFields = `
    workout_program_ID
    active
    archiver_ID
    creator_ID
    customer_ID
    date_archived
    date_created
    date_updated
    workout_program_name
    updater_ID
    user_ID
`;

const WorkoutProgramSetFields = `
    workout_program_set_ID
    workout_program_ID
    arm
    completed
    creator_ID
    date_created
    date_updated
    exercise
    reps
    save_status
    set_number
    torque
    updater_ID
    weight
    workout_number
`;

// export const GetUsers = gql`
//     query GetUsers($archiver_ID: Int, $customer_ID: Int, $user_type_ID: Int) {
//         users(archiver_ID: $archiver_ID, customer_ID: $customer_ID, user_type_ID: $user_type_ID) {
//             ${usersFields}
//             date_last_benchmark
//             date_last_workout
//         }
//     }
// `;

// export const GetUser = gql`
//     query GetUser($user_ID: ID) {
//         user (user_ID: $user_ID) {
//             ${usersFields}
//         }
//     }
// `;

// export const GetUsersQRCodes = gql`
//     query GetUsersQRCodes($user_ID: ID) {
//         usersQRCodes (user_ID: $user_ID) {
//             ${usersQRCodesFields}
//         }
//     }
// `;

// export const GetUsersQRCode = gql`
//     query GetUsersQRCode($user_QR_code_ID: ID) {
//         usersQRCode (user_QR_code_ID: $user_QR_code_ID) {
//             ${usersQRCodesFields}
//         }
//     }
// `;

export const GetWorkoutPrograms = gql`
    query GetWorkoutPrograms($user_ID: Int) {
        workout_programs (user_ID: $user_ID) {
            ${WorkoutProgramFields}
            WorkoutProgramSets {
                ${WorkoutProgramSetFields}
            }
        }
    }
`;

// export const GetUsersPTC = gql`
//     query GetUsersPTC($user_PTC_ID: ID) {
//         usersPTC (user_PTC_ID: $user_PTC_ID) {
//             ${usersPTCFields}
//         }
//     }
// `;

export const SaveWorkoutProgram = gql`
	mutation workoutProgramSave($input: WorkoutProgramInput) {
		workoutProgramSave (input: $input) {
            WorkoutProgram {
                ${WorkoutProgramFields}
            }
		}
	}
`;

// Multiple Records Save
export const SaveWorkoutProgramSets = gql`
	mutation workoutProgramSetsSave($input: WorkoutProgramSetsInput) {
		workoutProgramSetsSave (input: $input) {
            WorkoutProgramSets {
                workout_program_set_ID
                workout_program_ID
                arm
                completed
                creator_ID
                date_created
                date_updated
                exercise
                reps
                save_status
                set_number
                torque
                updater_ID
                weight
                workout_number
            }
		}
	}
`;

// export const SaveUserQRCode = gql`
// 	mutation usersQRCodeSave($input: UserQRCodeInput) {
// 		usersQRCodeSave (input: $input) {
//             ${usersQRCodesFields}
// 		}
// 	}
// `;

// export const SaveUserPTC = gql`
// 	mutation usersPTCSave($input: UserPTCInput) {
// 		usersPTCSave (input: $input) {
//             ${usersPTCFields}
// 		}
// 	}
// `;

// export const ParseUserQRCode = gql`
// 	mutation usersQRCodeParse($QR_code: String) {
// 		usersQRCodeParse (QR_code: $QR_code) {
//             ${usersQRCodesFields}
// 		}
// 	}
// `;

			// Response {
			// 	success
			// 	message
			// }



